// extracted by mini-css-extract-plugin
export default {"box":"box-w6R6L","header":"header-ZJ3ya","body":"body-rXRmI"};